import { z } from 'zod';

export enum receiptPaymentMethods {
  CREDIT = 'CREDIT',
  ETRANSFER = 'ETRANSFER',
  CHEQUE = 'CHEQUE',
  CASH = 'CASH',
}

export const receiptSchema = z.object({
  id: z.guid(),
  invoiceID: z.guid(),
  paymentMethod: z.enum([
    receiptPaymentMethods.CREDIT,
    receiptPaymentMethods.ETRANSFER,
    receiptPaymentMethods.CHEQUE,
    receiptPaymentMethods.CASH,
  ]),
  createdAt: z.string(),
  createdBy: z.guid(),
});

export const isReceipt = (obj: any): obj is z.infer<typeof receiptSchema> => {
  const parseResult = receiptSchema.safeParse(obj);
  return parseResult.success;
};

export type Receipt = z.infer<typeof receiptSchema>;
